import { render, staticRenderFns } from "./TradeFuturesRecords.vue?vue&type=template&id=9497c56e&scoped=true"
import script from "./TradeFuturesRecords.vue?vue&type=script&lang=js"
export * from "./TradeFuturesRecords.vue?vue&type=script&lang=js"
import style0 from "./TradeFuturesRecords.vue?vue&type=style&index=0&id=9497c56e&prod&lang=scss&scoped=true"
import style1 from "./TradeFuturesRecords.vue?vue&type=style&index=1&id=9497c56e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9497c56e",
  null
  
)

export default component.exports